export const enum HotelStayTagType {
  SpecialPrice = 'special_price',
  FreeCancellation = 'free_cancellation',
}
interface SpecialPriceTag {
  type: HotelStayTagType.SpecialPrice;
}

interface FreeCancellationTag {
  type: HotelStayTagType.FreeCancellation;
  until: string;
}

export type HotelStayTag = SpecialPriceTag | FreeCancellationTag;

export interface StayTagData {
  title: string;
  text: string;
  type: 'grey' | 'positive';
}
